import { FilterOptions } from "@/types/FilterOptions";
import { SearchFilterV4 } from "@/types/SearchFilter";
import { Checkbox } from "@components/ui/checkbox";
import {
  CommandGroup,
  CommandItem,
  CommandSeparator,
} from "@components/ui/command";
import { Trans } from "@lingui/react/macro";
import { ChevronLeftIcon } from "lucide-react";

export default function PageChannelNames({
  options,
  onChange,
  value,
  onBack,
}: {
  onChange?: (value: SearchFilterV4, clear?: boolean) => void;
  value: SearchFilterV4["channel_name"];
  options: FilterOptions["filter_channels"];
  onBack?: () => void;
}) {
  // Helpers
  const isArray = Array.isArray(value);

  const isAllSelected = isArray && value.length === options.length;

  return (
    <>
      {onBack && (
        <>
          <CommandGroup>
            <CommandItem onSelect={onBack}>
              <ChevronLeftIcon />
              <Trans>Tillbaka</Trans>
            </CommandItem>
          </CommandGroup>

          <CommandSeparator />
        </>
      )}

      {options.length > 1 ? (
        <>
          <CommandGroup>
            {isAllSelected ? (
              <CommandItem
                onSelect={() => {
                  onChange?.({
                    channel_name: undefined,
                  });
                }}
              >
                <Trans>Avmarkera alla</Trans>
              </CommandItem>
            ) : (
              <CommandItem
                onSelect={() => {
                  onChange?.({
                    channel_name: options.map(([value]) => value),
                  });
                }}
              >
                <Trans>Markera alla</Trans>
              </CommandItem>
            )}
          </CommandGroup>

          <CommandSeparator />
        </>
      ) : null}

      {options.length ? (
        <CommandGroup>
          {options.map(([channelName]) => {
            const isChecked = isArray
              ? value.includes(channelName)
              : value === channelName;

            return (
              <CommandItem
                data-filter-value={channelName}
                key={channelName}
                onSelect={() => {
                  if (isChecked) {
                    onChange?.({
                      channel_name: isArray
                        ? value.filter((it) => it !== channelName)
                        : undefined,
                    });
                  } else {
                    onChange?.({
                      channel_name: isArray
                        ? [...value, channelName]
                        : value
                          ? [value, channelName]
                          : [channelName],
                    });
                  }
                }}
              >
                <Checkbox checked={isChecked} className="pointer-events-none" />
                <span className="truncate">{channelName}</span>
              </CommandItem>
            );
          })}
        </CommandGroup>
      ) : null}
    </>
  );
}
